import CommunicationsDetails from './components/communicationsDetails/CommunicationsDetails';

const CommunicationsTab = () => {    

    return ( <CommunicationsDetails></CommunicationsDetails>);
}

export default CommunicationsTab;
